import { render, staticRenderFns } from "./userleave.vue?vue&type=template&id=6c168d3f&"
import script from "./userleave.vue?vue&type=script&lang=js&"
export * from "./userleave.vue?vue&type=script&lang=js&"
import style0 from "./userleave.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports